import PropTypes from 'prop-types';

import useGlobalStore from 'hooks/useGlobalStore';

export default function HowItWorks({ isAssortmentPreview }) {
    const { isMisfitsTheme } = useGlobalStore();

    return (
        <section className="mx-auto flex max-w-[820px] flex-col gap-30 px-25 py-30 md:items-center">
            <h1 className="text-body-lg font-grotesk-bold md:text-center">Cut your weekly grocery bill</h1>
            <div className="gap-4 grid grid-cols-1 md:grid-cols-[repeat(2,_auto)]">
                <p className="mb-20 md:mb-auto">
                    We&apos;ll start your cart every week with curated grocery picks. Then you can customize your order
                    by shopping organic produce and high-quality meats, seafood, dairy products, and bakery items for up
                    to 40% less than traditional grocery stores.
                </p>
                <img
                    className="row-span-2 mx-auto h-[325px] md:ml-15 md:max-w-[325px]"
                    alt="Shop on mobile"
                    src={
                        isMisfitsTheme
                            ? 'https://img-cdn.misfitsmarket.com/images/price_comparison_v3.gif'
                            : 'https://img-cdn.misfitsmarket.com/boysenberry/images/Price_Comparison_IF(6fps).gif'
                    }
                />
                <p className="text-body-xs mt-20 md:mt-auto">
                    {isAssortmentPreview
                        ? `Our stated price reflects the average price of this product across all delivery locations for the current week. We calculate our savings by comparing our price (excluding tax, shipping, and fees) to that of various grocery stores and online retailers, as well as the product's  manufacturer's suggested retail price (MSRP), if applicable. Actual price and savings may vary from week to week based on your delivery location and other factors. Products subject to availability.`
                        : '*Prices are compared to purchasing similar items at retail grocery stores (excluding tax, shipping, and fees). Actual prices and savings may vary. '}
                </p>
            </div>
        </section>
    );
}

HowItWorks.propTypes = {
    isAssortmentPreview: PropTypes.bool,
};

HowItWorks.defaultProps = {
    isAssortmentPreview: false,
};
